import {
    Box,
    Text,
    Table,
    Thead,
    Td,
    Tr,
    Th,
    Tbody,
    Button,
    Spinner,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    TabIndicator
} from "@chakra-ui/react";
import ReactDragListView from "react-drag-listview/lib/index.js";
import { ProductItem } from "../../components/ProductItem";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { useProducts } from "./useProducts"
import "./ProductsPage.scss";
import { HelmetComponent } from "../../components/HelmetComponent";
import { Pagination } from "../../components/Pagination";

export const ProductsPage = () => {
    const {
        user,
        catalog,
        updateItemListOrder,
        catalogId,
        archievedProducts,
        updateProduct,
        loading,
        publisher,
        userRole,
        isCatalogAdmin,
        totalProducts,
        PageSize,
        currentPage,
        onPageChange,
        searchText,
        searchedProducts,
        productsLoading,
        currentProductsList
    } = useProducts();
    return (
        <>
            <HelmetComponent title={`${catalog.catalogName} - Home - ${user.firstName} ${user.lastName}`} />
            {loading && <LoadingOverlay />}
            <Tabs position='relative' variant='unstyled'>
                <TabList>
                    <Tab>Active</Tab>
                    <Tab>Archived</Tab>
                </TabList>
                <TabIndicator mt='-1.5px' height='2px' bg='blue.500' borderRadius='1px' />
                <TabPanels>
                    <TabPanel>
                        <>
                            {catalog.products.length > 0 ?
                                <ReactDragListView
                                    nodeSelector="tr.item-tr"
                                    handleSelector="button.item-list-order-button"
                                    ignoreSelector="tr.table-head-row"
                                    onDragEnd={(fromIndex, toIndex) =>
                                        updateItemListOrder(fromIndex, toIndex)
                                    }
                                >
                                    <Table size="sm" variant="simple" mt="5" mb="5">
                                        <Thead>
                                            <Tr className="catalog-table-head-row">
                                                <Th
                                                    size="lg"
                                                    fontWeight="800"
                                                    color="#424770"
                                                    letterSpacing="wide"
                                                >
                                                    Name
                                                </Th>
                                                <Th
                                                    size="lg"
                                                    fontWeight="800"
                                                    color="#424770"
                                                    letterSpacing="wide"
                                                >
                                                    Type
                                                </Th>
                                                <Th
                                                    size="lg"
                                                    fontWeight="800"
                                                    color="#424770"
                                                    letterSpacing="wide"
                                                >
                                                    Publish Status
                                                </Th>
                                                <Th
                                                    size="lg"
                                                    fontWeight="800"
                                                    color="#424770"
                                                    letterSpacing="wide"
                                                    colSpan={userRole.isStaff ? 1 : 3}
                                                >
                                                    Store Status
                                                </Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {
                                                productsLoading ?
                                                    <Tr>
                                                        <Td></Td>
                                                        <Td></Td>
                                                        <Td><Box
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            w="100%"
                                                            h="80vh"
                                                        >
                                                            <Spinner
                                                                thickness="4px"
                                                                speed="0.65s"
                                                                emptyColor="gray.200"
                                                                color="blue.500"
                                                                size="xl"
                                                            />
                                                        </Box></Td>
                                                        <Td></Td>
                                                    </Tr>
                                                    :
                                                    <ProductItem
                                                        productItems={currentProductsList
                                                            .filter((product) => product.productStatus !== "Removed")
                                                            .map((product) => ({
                                                                ...product,
                                                                name: product.productName,
                                                                status: product.productStatus,
                                                            }))}
                                                        catalogId={catalogId}
                                                        catalogStatus={catalog.catalogStatus}
                                                        user={user}
                                                        stripeAccountId={publisher?.stripeAccountId}
                                                        userRole={userRole}
                                                        isCatalogAdmin={isCatalogAdmin}
                                                    />
                                            }
                                        </Tbody>
                                    </Table>
                                </ReactDragListView>
                                :
                                <Text
                                    color="#424770"
                                    size="sm"
                                    mt="10"
                                >
                                    No products to show. Please start adding.
                                </Text>
                            }
                            {searchText !== "" && searchedProducts.length === 0 && (
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    <Text fontSize="lg">
                                        No search found for the {searchText}
                                    </Text>
                                </Box>
                            )}
                            {searchText === "" && (
                                <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    totalCount={totalProducts}
                                    pageSize={PageSize}
                                    onPageChange={onPageChange}
                                />
                            )}

                        </>
                    </TabPanel>
                    <TabPanel>
                        <>
                            <Box mt="10">
                                {archievedProducts.length === 0 && (
                                    <Text
                                        color="#424770"
                                        size="sm"
                                        mt="1"
                                    >
                                        No product archived.
                                    </Text>
                                )}
                            </Box>
                            <Table size="sm" variant="simple" mb="5">
                                <Tbody>
                                    {archievedProducts.length > 0 &&
                                        archievedProducts.map((archievedProduct) => (
                                            <Tr key={archievedProduct.id} className="archive-tr">
                                                <Td className="catalog-link">{archievedProduct.productName}</Td>
                                                {<Td visibility="hidden">&nbsp;</Td>}
                                                {<Td visibility="hidden">&nbsp;</Td>}
                                                {<Td visibility="hidden">&nbsp;</Td>}
                                                <Td>
                                                    <Button
                                                        onClick={() =>
                                                            updateProduct(
                                                                archievedProduct.id
                                                            )
                                                        }
                                                        variant="outline"
                                                        borderColor="red.500"
                                                        color="red.500"
                                                        _hover={{ bg: "red.100" }}
                                                        width="100px"
                                                    >
                                                        Unarchive
                                                    </Button>
                                                </Td>
                                            </Tr>
                                        ))}
                                </Tbody>
                            </Table>
                        </>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </>
    );
};
